import React from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { GRID_OPTIONS } from '../../../../HelperMethods/AgGridConstants';
import { convertUTCDateStringToYYYYMMDDHHMMSSFormat } from '../../../../HelperMethods/DateUtils';
import { parseJSONStringToObject } from '../../../../HelperMethods/UtilityFunctions';

const TasksFromRulesList = ({ rulesEvaluated }) => {
  const rowData = parseJSONStringToObject(rulesEvaluated || []).map((ruleEvaluated) =>
    parseJSONStringToObject(ruleEvaluated)
  );
  const onRowDoubleClicked = (event) => {
    window.open(`taskViewPage/task/update/${event.data.taskId}`, '_blank');
  };

  const onCellClicked = (event) => {
    if (event.colDef.field === 'taskNumber') {
      window.open(`taskViewPage/task/update/${event.data.taskId}`, '_blank');
    }
  };

  return (
    <>
      <div
        className="ag-theme-balham"
        style={{
          height: '100%',
          width: '100%',
          minHeight: '238px',
        }}
      >
        <AgGridReact
          {...GRID_OPTIONS}
          statusBar={{
            statusPanels: [
              {
                statusPanel: 'agTotalAndFilteredRowCountComponent',
                align: 'left',
              },
            ],
          }}
          onRowDoubleClicked={onRowDoubleClicked}
          onRowDataChanged={(params) => {
            params.api.sizeColumnsToFit();
          }}
          columnDefs={[
            {
              headerName: 'Task #',
              field: 'taskNumber',
              type: 'link',
              cellRenderer: (params) => {
                return params.value
                  ? <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{params.value ?? 'NA'}</span>
                  : <span>NA</span>;
              },
            },
            {
              headerName: 'Task Name',
              field: 'taskTypeName',
              cellRenderer: (params) => {
                return <span>{params.value ?? 'NA'}</span>;
              },
            },
            {
              headerName: 'Rule Name',
              field: 'ruleName',
              cellRenderer: (params) => {
                return <span>{params.value ?? 'NA'}</span>;
              },
            },
            {
              headerName: 'API Name',
              field: 'triggerAPIName',
              cellRenderer: (params) => {
                return <span>{params.value ?? 'NA'}</span>;
              },
            },
            {
              headerName: 'API Trigger Success',
              field: 'apiTriggerSuccess',
              width: 200,
              valueFormatter: (x) => {
                if (x.value === true) {
                  return 'Yes';
                }
                if (x.value === false) {
                  return 'No';
                }
                return 'NA';
              },
            },
            {
              headerName: 'Date',
              field: 'createdOn',
              width: 200,
              valueFormatter: (x) => (x.value ? convertUTCDateStringToYYYYMMDDHHMMSSFormat(x.value) : ''),
            },
          ]}
          onCellClicked={onCellClicked}
          rowData={rowData}
          icons={{
            menu: '<i class="fa fa-filter"></i>',
          }}
        />
      </div>
    </>
  );
};

export default TasksFromRulesList;
